
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[country]/[language]/person/[name]/[id]",
      function () {
        return require("private-next-pages/[country]/[language]/person/[name]/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[country]/[language]/person/[name]/[id]"])
      });
    }
  